if (!window.ccCardAtcFeedbackDefined) {
  window.ccCardAtcFeedbackDefined = true;

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;

    const btn = form.querySelector('.cc-card__atc');
    if (!btn) return;

    btn.classList.remove('is-loading');
  });
}
